import { render, staticRenderFns } from "./feather.vue?vue&type=template&id=e56f41d6&"
import script from "./feather.vue?vue&type=script&lang=js&"
export * from "./feather.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports